import { FC, useCallback } from 'react';

import ListItemIcon from '@mui/material/ListItemIcon';
import MenuItem from '@mui/material/MenuItem';

import Logout from '@mui/icons-material/Logout';

const UserMenuLogout: FC = () => {
  const handleClick = useCallback(() => {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');

    window.location.reload();
  }, []);

  return (
    <MenuItem onClick={handleClick}>
      <ListItemIcon>
        <Logout fontSize="small" />
      </ListItemIcon>
      Atsijungti
    </MenuItem>
  );
};

export default UserMenuLogout;
